import { render, staticRenderFns } from "./zzAdmin.vue?vue&type=template&id=469b9f02&scoped=true"
import script from "./zzAdmin.vue?vue&type=script&lang=js"
export * from "./zzAdmin.vue?vue&type=script&lang=js"
import style0 from "./zzAdmin.vue?vue&type=style&index=0&id=469b9f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469b9f02",
  null
  
)

export default component.exports